(function() {
  // チラつき防止
  document.documentElement.style.visibility = 'visible';

  // PWAモード判定
  var isPWA = window.matchMedia('(display-mode: standalone)').matches
    || window.navigator.standalone === true;

  if (!isPWA) return;

  // 通常コンテンツを非表示
  var mainContent = document.getElementById('MainContent');
  if (mainContent) mainContent.style.display = 'none';

  // ヘッダー非表示（アナウンスバーは残す）
  var headerSections = document.querySelectorAll('.shopify-section-group-header-group');
  headerSections.forEach(function(section) {
    if (section.id && section.id.indexOf('announcement') !== -1) return;
    if (section.querySelector('.announcement')) return;
    section.style.display = 'none';
  });

  // フッター非表示
  var footer = document.querySelector('.shopify-section-group-footer-group');
  if (footer) footer.style.display = 'none';

  // アナウンスバーをpwa-topの先頭に移動
  var pwaTop = document.getElementById('pwa-top');
  headerSections.forEach(function(section) {
    var isAnnouncement = (section.id && section.id.indexOf('announcement') !== -1)
      || section.querySelector('.announcement');
    if (!isAnnouncement) return;
    section.style.position = 'relative';
    section.style.top = 'auto';
    section.style.marginTop = '52px';
    pwaTop.insertBefore(section, pwaTop.firstChild);
  });

  // PWA専用トップを表示
  if (pwaTop) pwaTop.style.display = 'block';

  // メニューバーを表示
  var pwaNav = document.getElementById('pwa-nav');
  if (pwaNav) pwaNav.style.display = 'flex';

  // コレクション読み込み
  function loadCollection(handle, containerId) {
    fetch('/collections/' + handle + '/products.json?limit=10')
      .then(function(res) { return res.json(); })
      .then(function(data) {
        var container = document.getElementById(containerId);
        if (!container) return;
        data.products.forEach(function(product) {
          var img = product.images[0] ? product.images[0].src : '';
          var price = '¥' + Math.round(product.variants[0].price).toLocaleString('ja-JP');
          var item = document.createElement('a');
          item.href = '/products/' + product.handle;
          item.className = 'pwa-scroll__item';
          item.innerHTML =
            '<img src="' + img + '" alt="' + product.title + '">' +
            '<div class="pwa-scroll__item__title">' + product.title + '</div>' +
            '<div class="pwa-scroll__item__price">' + price + '</div>';
          container.appendChild(item);
        });
      });
  }

  // 起動時モーダル（セッション中1回のみ）
  if (window.location.pathname === '/') {
    var overlay = document.getElementById('pwa-modal-overlay');
    if (overlay) {
      var modalShown = sessionStorage.getItem('pwa-modal-shown');
      var urlParams = new URLSearchParams(window.location.search);
      if (!modalShown && !urlParams.has('discount')) {
        overlay.style.display = 'flex';
        sessionStorage.setItem('pwa-modal-shown', 'true');
        var closeBtn = document.getElementById('pwa-modal-close');
        if (closeBtn) {
          closeBtn.addEventListener('click', function() {
            overlay.style.display = 'none';
          });
        }
        overlay.addEventListener('click', function(e) {
          if (e.target === overlay) overlay.style.display = 'none';
        });
      }
    }
  }

  // SHOP NOWボタン
  var shopNowBtn = document.querySelector('.pwa-modal__btn');
  if (shopNowBtn) {
    shopNowBtn.addEventListener('click', function() {
      sessionStorage.setItem('pwa-shopnow-pressed', 'true');
    });
  }

  // 全ページにクーポンパラメーター付与
  (function() {
    var shopNowPressed = sessionStorage.getItem('pwa-shopnow-pressed');
    if (!shopNowPressed) return;
    var urlParams = new URLSearchParams(window.location.search);
    if (!urlParams.has('discount')) {
      urlParams.set('discount', 'TMT10APP');
      var newUrl = window.location.pathname + '?' + urlParams.toString() + window.location.hash;
      window.history.replaceState(null, '', newUrl);
    }
    document.addEventListener('click', function(e) {
      var link = e.target.closest('a');
      if (!link) return;
      var href = link.getAttribute('href');
      if (!href || href.startsWith('http') || href.startsWith('mailto') || href.startsWith('#')) return;
      if (href.indexOf('discount=') !== -1) return;
      var separator = href.indexOf('?') !== -1 ? '&' : '?';
      link.setAttribute('href', href + separator + 'discount=TMT10APP');
    });
  })();

  // トップページのみコレクション読み込み
  if (window.location.pathname === '/') {
    loadCollection('pre-order', 'pwa-preorder-scroll');
    loadCollection('coming-soon', 'pwa-comingsoon-scroll');
    loadCollection('new-item', 'pwa-newitem-scroll');
  }

  /* =============================================
     メニューバー タブ切り替え
     ============================================= */
  document.querySelectorAll('.pwa-nav__item').forEach(function(item) {
    item.addEventListener('click', function() {
      document.querySelectorAll('.pwa-nav__item').forEach(function(n) {
        n.classList.remove('is-active');
      });
      item.classList.add('is-active');

      document.querySelectorAll('.pwa-tab').forEach(function(t) {
        t.classList.remove('is-active');
      });
      var target = document.getElementById('pwa-tab-' + item.dataset.tab);
      if (target) target.classList.add('is-active');

      // スクロールをトップに戻す
      var pwaTop = document.getElementById('pwa-top');
      if (pwaTop) pwaTop.scrollTop = 0;

      // 会員証タブ：バーコード生成（初回のみ）
      if (item.dataset.tab === 'membership' && window.__pwaCustomerId) {
        var barcodeEl = document.getElementById('pwa-barcode');
        if (barcodeEl && !barcodeEl.dataset.rendered) {
          JsBarcode('#pwa-barcode', window.__pwaCustomerId, {
            format: 'CODE128',
            lineColor: '#000',
            background: '#fff',
            width: 2,
            height: 80,
            displayValue: false
          });
          barcodeEl.dataset.rendered = 'true';
        }
      }

      // アナウンスバーの表示切り替え（HOMEのみ表示）
      var announcements = document.querySelectorAll('.shopify-section-group-header-group');
      announcements.forEach(function(section) {
        var isAnnouncement = (section.id && section.id.indexOf('announcement') !== -1)
          || section.querySelector('.announcement');
        if (!isAnnouncement) return;
        section.style.display = item.dataset.tab === 'home' ? '' : 'none';
      });
    });
  });

})();
